import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const ConfirmModalWrapper = styled(Modal)`
.confirm_modal {
  align-items: center;
  margin-top: 30vh;
  width: 40vw;
  overflow: hidden;
  border-radius: 12px;

  @media (max-width: ${TABLET_WIDTH}px) {
    width: 96vw;
  }
  
  .modal_text {
    width: 80%;
    margin: 0% 10%;
    margin-bottom: 5%;
    text-align: center;
    font-size: 20px;
  }

  .buttons {
    width: 80%;
    margin: 0% 10%;
    margin-bottom: 5%;

    
  }
}
`;



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/components/styles.js